export const isBeta = () => localStorage.getItem('environment').toLowerCase() === 'beta';
export const isProduction = () => localStorage.getItem('environment').toLowerCase() === 'production';
export const isIntegrations = () => localStorage.getItem('environment').toLowerCase() === 'internal';
export const isStaging = () => localStorage.getItem('environment').toLowerCase() === 'staging';
export const isQA1 = () => localStorage.getItem('environment').toLowerCase() === 'qa1';
export const isDevelopment = () => !(isBeta() || isProduction() || isIntegrations() || isStaging());
